import { render, staticRenderFns } from "./metrics_empty_state.vue?vue&type=template&id=60bdc958&scoped=true&"
import script from "./metrics_empty_state.vue?vue&type=script&lang=js&"
export * from "./metrics_empty_state.vue?vue&type=script&lang=js&"
import style0 from "./metrics_empty_state.vue?vue&type=style&index=0&id=60bdc958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdc958",
  null
  
)

export default component.exports